<template>
  <div class="system">
    <HeaderReturn title="设置"></HeaderReturn>

    <div class="Assets_ul">
      <ul>
        <li
          v-for="(item, index) in TeamList"
          :key="item.id"
          @click="goLink(item.path)"
        >
          <div class="d-flex justify-between">
            <p class="d-flex">
              <img
                :src="
                  require('../../assets/img/tabar/' + (item.id + 1) + '.png')
                "
                alt=""
                srcset=""
                style="width: 30px; height: 30px; margin-right: 10px"
              />

              {{ item.txt }}
            </p>
            <img
              src="../../assets/img/page/jt.png"
              alt=""
              srcset=""
              style="width: 30px; height: 30px"
            />
          </div>
        </li>
      </ul>
    </div>
    <div class="system_btn" @click="dialogVisible = true">退出登录</div>

    <div class="system_dialog">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="90%">
        <span>此操作将退出登录，是否继续？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon } from "vant";
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      UrlYqhy: "",
      Aeccter: {
        money: 75.8193,
      },
      TeamList: [
        {
          txt: "APP版本",
          id: 0,
          path: "/system/versions",
        },
        {
          txt: "安全中心",
          id: 1,
          path: "/system/safety",
        },
        {
          txt: "订单客服",
          id: 2,
        },
        {
          txt: "联系客服",
          id: 3,
          path: "2",
        },
        {
          txt: "关于我们",
          id: 4,
          path: "/system/aboutUs",
        },
      ],
      dialogVisible: false,
    };
  },
  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.UrlYqhy = window.location.origin + "/#/reg?promotion=" + "1111";
  },
  methods: {
    qd() {
      localStorage.removeItem("TOKEN");
      sessionStorage.removeItem("ms_user");
      localStorage.removeItem("MEMBER");

      this.$router.push("/member/login");
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path, item) {
      if (path) {
        if(path=='2'){
          return window.open('https://t.me/limekizi')
        }
        this.$router.push({
          path,
          query: {
            item: JSON.stringify(item),
          },
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.system {
  margin: 50px 10px;

  .system_dialog {
    ::v-deep .el-dialog__wrapper {
      background: #090101;
      opacity: 0.8;
    }

    ::v-deep .el-dialog,
    ::v-deep .el-button {
      background: rgba(20, 132, 195, 0.2);

      color: #ffffff;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;
    
      border-radius: 4px;
    }
    ::v-deep .el-dialog {
      background: url(../../assets/img/page/TC-345X233.png) no-repeat;
      background-size: 100% 100%;
    }

    ::v-deep .el-dialog__title,
    ::v-deep .el-dialog__body {
      color: #ffffff;
    }
  }

  ::v-deep .van-nav-bar__title {
    color: #f89b19;
    font-size: 20px;
    font-weight: 600;
  }

  .system_btn {
    /* Frame 147 */

    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;

    position: fixed;
    width: 90%;
    // height: 42px;
    left: 0px;
    right: 0px;
    // top: 735px;
    bottom: 60px;
    margin: 0px auto;

    /* 黄/主题 */

    background: #f89b19;
    border-radius: 4px;
    color: #ffffff;
  }

  .Assets_grid {
    ul {
      display: grid;
      justify-content: space-between;
      grid-template-columns: 25% 25% 25% 25%;
      text-align: center;

      li {
        margin-top: 17px;

        img {
          // margin: 10px 0;
        }

        p {
          // padding: 8.74px 0px 15px 0;
          color: #fff;
          font-size: 12px;
        }
      }

      // align-items: center;
    }
  }

  .Assets_ul {
    ul {
      li {
        margin: 20px 10px;
 
        border: 1px solid #f89b19;
        border-radius: 4px;

        div {
          &:nth-child(1) {
            padding: 10px 15px;

            p {
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              line-height: 30px;
              text-align: center;

              color: #ffffff;
            }
          }
        }
      }
    }
  }
}
</style>
